export const actionTypes = {
    GET_FOOD_GROUP: 'GET_FOOD_GROUP',
    SET_FOOD_GROUP: 'SET_FOOD_GROUP',
    GET_LIST_FOOD: 'GET_LIST_FOOD',
    SET_LIST_FOOD: 'SET_LIST_FOOD',
    SEARCH_FOOD: 'SEARCH_FOOD',
    GET_ONE: 'GET_ONE',
}

export const getFoodGroup = payload => ({
    type: actionTypes.GET_FOOD_GROUP,
    payload,
})

export const setFoodGroup = payload => ({
    type: actionTypes.SET_FOOD_GROUP,
    payload,
})

export const getListFood = payload => ({
    type: actionTypes.GET_LIST_FOOD,
    payload,
})

export const searchFood = payload => ({
    type: actionTypes.SEARCH_FOOD,
    payload,
})

export const getOne = payload => ({
    type: actionTypes.GET_ONE,
    payload,
})
